<template>
  <div>
    <v-form>
      <v-text-field
        v-model="store.name"
        :error-messages="errors.name"
        :label="$t('Name')"
        @input="nameValidation"
      />
      <v-text-field
        v-if="!hideCode"
        :disabled="isValueImmutable"
        v-model="store.code"
        :error-messages="errors.code"
        :label="$t('Code')"
        @input="codeValidation"
      />
      <v-text-field
        v-model="storeUrl"
        :readonly="isValueImmutable"
        :error-messages="errors.url"
        :label="$t('Url')"
        :prefix="prefix"
        :suffix="suffix"
        @input="urlValidation"
      />
      <p>{{ $t('Change console primary color') }}</p>
      <slider
        v-model="store.color"
        style="width: 100%;"
      />
    </v-form>
  </div>
</template>

<script>
import { Slider } from 'vue-color'

export default {
  name: 'StoreForm',

  components: {
    Slider
  },

  props: {
    store: {
      type: Object,
      default: () => ({
        name: '',
        color: '#009688',
        code: '',
        url: '',
        template: 'default'
      })
    },
    isValueImmutable: {
      type: Boolean,
      default: true
    },
    hideCode: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      prefix: 'https://',
      suffix: '.futureecom.io',
      errors: {
        name: '',
        code: '',
        color: '',
        url: ''
      }
    }
  },

  computed: {
    storeUrl: {
      set (value) {
        this.store.url = `${this.prefix}${value}${this.suffix}`
      },
      get () {
        return this.store.url.replace(this.prefix, '').replace(`${this.suffix}`, '')
      }
    }
  },

  async created () {
    this.nameValidation()
    this.errors.code = ''
  },

  methods: {
    codeValidation () {
      this.errors.code = this.store.code.match(/\s/g) ? this.$t('No whitespaces allowed') : ''
      this.containsErrors()
    },

    nameValidation () {
      this.errors.name = !this.store.name ? this.$t('Field cannot be empty') : ''
      this.containsErrors()
    },

    urlValidation () {
      this.errors.url = !this.store.url ? this.$t('Field cannot be empty') : ''
      if (this.errors.url) {
        this.containsErrors()
        return
      }

      try {
        // eslint-disable-next-line no-new
        new URL(this.store.url)
      } catch (e) {
        this.errors.url = this.$t('Invalid URL format')
        this.containsErrors()
      }
    },

    containsErrors () {
      let status = !!(this.errors.name || this.errors.code || this.errors.url)
      this.$emit('containErrors', status)
    }
  }
}
</script>
